import header from './layout/header'
import pager from './shared/pager'

import signin from './components/signin'
import unauthorized from './components/app.unauthorized'
import timelines from './components/app.timelines'

import account_index from './pages/account.index'
import account_change_password from './pages/account.change-password'
import account_profile from './pages/account.profile'
import forget_password from './pages/forget-password'
import reset_password from './pages/reset-password'
import signup from './pages/signup'


import admin_index from './pages/admin.index'
import admin_orders from './pages/admin.orders'
import admin_order from './pages/admin.order'
import admin_contents from './pages/admin.contents'
import admin_content from './pages/admin.content'
import admin_roles from './pages/admin.roles'
import admin_role from './pages/admin.role'
import admin_role_claims from './pages/admin.role-claims'
import admin_users from './pages/admin.users'
import admin_user from './pages/admin.user'
import admin_user_roles from './pages/admin.user.roles'
import admin_claims from './pages/admin.claims'
import admin_claim from './pages/admin.claim'

export default {
    header: header,
    shared: {
        pager: pager
    },
    components: {
        signin: signin,
        app: {
            unauthorized: unauthorized,
            timelines: timelines,
        },
    },
    pages: {
        signup: signup,
        forget_password: forget_password,
        reset_password: reset_password,
        account: {
            index: account_index,
            change_password: account_change_password,
            profile: account_profile
        },
        admin: {
            index: admin_index,
            orders: admin_orders,
            order: admin_order,
            contents: admin_contents,
            content: admin_content,
            roles: admin_roles,
            role: admin_role,
            role_claims: admin_role_claims,
            users: admin_users,
            user: admin_user,
            user_roles: admin_user_roles,
            claims: admin_claims,
            claim: admin_claim,

        }
    }
}
